function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types'; // components

import Arrows from './Arrows';
import TimesList from './TimesList';
import Icons from '../icons/collection';
import TimeSlotDropdown from './TimeSlotDropdown'; // styles

import { DailySlotWrapper, SeeMoreText, TimeSlotWrapper, WeeklySlotWrapper } from './styled/styles'; // utils

import { DateFormatHandler } from '../utils/dateFormat';

var TimeSlot = function TimeSlot(_ref) {
  var availableTimesList = _ref.availableTimesList,
      _ref$analyticsClick = _ref.analyticsClick,
      analyticsClick = _ref$analyticsClick === void 0 ? function () {} : _ref$analyticsClick,
      _ref$activeButtonValu = _ref.activeButtonValue,
      activeButtonValue = _ref$activeButtonValu === void 0 ? '' : _ref$activeButtonValu,
      _ref$bgColorSelected = _ref.bgColorSelected,
      bgColorSelected = _ref$bgColorSelected === void 0 ? '' : _ref$bgColorSelected,
      className = _ref.className,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? undefined : _ref$dataAnalyticsId,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? null : _ref$dataAnalyticsLab,
      _ref$expand = _ref.expand,
      expand = _ref$expand === void 0 ? false : _ref$expand,
      _ref$getExpandValue = _ref.getExpandValue,
      getExpandValue = _ref$getExpandValue === void 0 ? function () {} : _ref$getExpandValue,
      endDate = _ref.endDate,
      _ref$numberOfColumns = _ref.numberOfColumns,
      numberOfColumns = _ref$numberOfColumns === void 0 ? 3 : _ref$numberOfColumns,
      onClick = _ref.onClick,
      startDate = _ref.startDate,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'white' : _ref$theme,
      _ref$viewType = _ref.viewType,
      viewType = _ref$viewType === void 0 ? 'base' : _ref$viewType,
      restProps = _objectWithoutProperties(_ref, ["availableTimesList", "analyticsClick", "activeButtonValue", "bgColorSelected", "className", "dataAnalyticsId", "dataAnalyticsLabel", "expand", "getExpandValue", "endDate", "numberOfColumns", "onClick", "startDate", "theme", "viewType"]);

  var _useState = useState(availableTimesList),
      _useState2 = _slicedToArray(_useState, 2),
      availableTimes = _useState2[0],
      setAvailableTimes = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      calendarDates = _useState4[0],
      setCalendarDates = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      calendarTime = _useState6[0],
      setCalendarTime = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      seeMoreToggle = _useState8[0],
      setSeeMoreToggle = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      arrowToggle = _useState10[0],
      setArrowToggle = _useState10[1];

  var _useState11 = useState(activeButtonValue),
      _useState12 = _slicedToArray(_useState11, 2),
      btnActive = _useState12[0],
      setBtnActive = _useState12[1];

  var _useState13 = useState(0),
      _useState14 = _slicedToArray(_useState13, 2),
      weeklyCountSeeMore = _useState14[0],
      setWeeklyCountSeeMore = _useState14[1];

  var setAvailableTimesList = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var timesList, count, firstDate, lastDate, datesLength, dates, res, i, j, obj, newObj, val, _ref3, _timesList;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // weekly overrides daily and default
              if (viewType === 'weekly') {
                // return a nested array by dates
                timesList = availableTimes.reduce(function (val, obj) {
                  var newVal = val;
                  var dateKey = DateFormatHandler(new Date(obj.datetime), 'custom', {
                    month: 'numeric',
                    day: 'numeric',
                    year: 'numeric'
                  });
                  (newVal[dateKey] = val[dateKey] || []).push(_objectSpread({
                    datetime: obj.datetime
                  }, obj));
                  return val;
                }, []).sort(); // determine whether to show "see more times" toggle if length of times for each dates is more than 4

                count = 0;
                Object.values(timesList).map(function (times) {
                  if (times.length > 4) count += 1;
                });
                setWeeklyCountSeeMore(count); // TODO: Refactor for more elegant approach on setting null for missing dates in timesList array

                firstDate = Object.entries(timesList)[0][0];
                lastDate = Object.entries(timesList)[Object.entries(timesList).length - 1][0];
                datesLength = Math.floor(Date.parse(lastDate) / 86400000 - Date.parse(firstDate) / 86400000 + 1);
                dates = lastDate && firstDate && _toConsumableArray(Array(datesLength).keys()).map(function (k) {
                  return new Date(86400000 * k + Date.parse(firstDate)).toISOString().slice(0, 10).replace(/-0(\d)$/, '-$1');
                });
                res = [];

                for (i = 0, j = 0; i < dates.length; i += 1) {
                  obj = dates[i];
                  obj = obj.replace(/-/g, '/');
                  newObj = obj.split('/');
                  obj = "".concat(newObj[1], "/").concat(newObj[2], "/").concat(newObj[0]);
                  obj = new Date(obj).toLocaleDateString(); // j += 1 will skew the data
                  // eslint-disable-next-line no-plusplus

                  val = obj === Object.keys(timesList)[j] ? Object.values(timesList)[j++] : null;
                  res[i] = {
                    date: DateFormatHandler(obj, 'date'),
                    slots: val
                  };
                }

                ;
                setCalendarTime(res);
              } else {
                _timesList = (_ref3 = []).concat.apply(_ref3, _toConsumableArray(Object.values(availableTimes))).sort();
                setAvailableTimes(_timesList);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function setAvailableTimesList() {
      return _ref2.apply(this, arguments);
    };
  }(); // map the time slot


  var setCalendarTimeSlots = function setCalendarTimeSlots(selectedDate) {
    var _timeSlots;

    var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
    // filter and sort times by the weekday, month, and day parameter and available times
    var timeSlots = availableTimes.filter(function (_ref4) {
      var datetime = _ref4.datetime;
      var slot = new Date(Date.parse(datetime));
      var reformattedDate = DateFormatHandler(slot, 'date');
      return selectedDate === reformattedDate;
    }).sort(function (a, b) {
      return new Date(a.datetime).getTime() - new Date(b.datetime).getTime();
    });
    timeSlots = (_timeSlots = timeSlots) !== null && _timeSlots !== void 0 && _timeSlots.length ? timeSlots : _toConsumableArray(Array(days)).map(function () {
      return '-';
    });
    setCalendarTime(timeSlots);
  }; // set the first available calendar day


  var setFirstAvailableDay = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var firstAvailableDay, calendarDayArr;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              firstAvailableDay = startDate || availableTimes[0].datetime;
              calendarDayArr = [];
              availableTimes.map(function (day) {
                calendarDayArr.push(DateFormatHandler(day.datetime, 'date'));
                return calendarDayArr;
              }); // filter out duplicate calendar day names and sort ascending

              calendarDayArr = _toConsumableArray(new Set(calendarDayArr)).sort(function (a, b) {
                return new Date(a) - new Date(b);
              });
              setCalendarDates(calendarDayArr);

              if (viewType !== 'weekly') {
                setCalendarTimeSlots(DateFormatHandler(firstAvailableDay, 'date'));
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function setFirstAvailableDay() {
      return _ref5.apply(this, arguments);
    };
  }(); // update time slots on date change handler


  var onChangeDate = function onChangeDate(event) {
    setCalendarTimeSlots(event);
  }; // set active button selected


  var onClickHandler = function onClickHandler(value) {
    setBtnActive(value);
    onClick(value);
  };

  var onExpandHandler = function onExpandHandler() {
    setSeeMoreToggle(!seeMoreToggle);
    getExpandValue(seeMoreToggle);
  };

  var toggleArrows = function toggleArrows(val, type) {
    switch (type) {
      case 'next':
        setArrowToggle(arrowToggle + 1);
        break;

      case 'prev':
        setArrowToggle(arrowToggle - 1);
        break;

      default:
        break;
    }

    analyticsClick(val);
  };

  useEffect(function () {
    setAvailableTimes(availableTimesList);

    if (!calendarDates) {
      setFirstAvailableDay();
    }

    setAvailableTimesList();
    return function () {};
  }, [availableTimesList]);
  return /*#__PURE__*/React.createElement(TimeSlotWrapper, _extends({
    viewType: viewType
  }, restProps), availableTimes && viewType !== 'weekly' && /*#__PURE__*/React.createElement(DailySlotWrapper, null, viewType === 'daily' && (calendarDates === null || calendarDates === void 0 ? void 0 : calendarDates.length) && /*#__PURE__*/React.createElement(TimeSlotDropdown, {
    dates: calendarDates,
    onChange: onChangeDate,
    dataAnalyticsLabel: dataAnalyticsLabel
  }), calendarTime && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(TimesList, {
    theme: theme,
    className: "scl-timeSlot-list ".concat(className),
    btnActive: btnActive,
    times: calendarTime,
    onClick: function onClick(event) {
      return onClickHandler(event);
    },
    expand: !expand && seeMoreToggle,
    viewType: viewType,
    dataAnalyticsId: dataAnalyticsId,
    dataAnalyticsLabel: dataAnalyticsLabel
  }))), viewType === 'weekly' && calendarTime && /*#__PURE__*/React.createElement(WeeklySlotWrapper, {
    numberOfColumns: numberOfColumns,
    dataAnalyticsLabel: dataAnalyticsLabel
  }, viewType === 'weekly' && /*#__PURE__*/React.createElement(Arrows, {
    toggleArrow: toggleArrows,
    hideArrows: arrowToggle,
    dataAnalyticsLabel: dataAnalyticsLabel,
    calendarWeekLength: calendarTime.length - numberOfColumns
  }), viewType === 'weekly' && calendarTime && calendarTime.map(function (date) {
    return /*#__PURE__*/React.createElement(TimesList, {
      theme: theme,
      className: "scl-timeSlot-list ".concat(className),
      bgColorSelected: bgColorSelected,
      key: date.date,
      times: date,
      btnActive: btnActive,
      onClick: function onClick(event) {
        return onClickHandler(event);
      },
      expand: !expand && seeMoreToggle,
      viewType: viewType,
      onClickToggle: function onClickToggle() {
        return setSeeMoreToggle(!seeMoreToggle);
      },
      dataAnalyticsId: dataAnalyticsId,
      dataAnalyticsLabel: dataAnalyticsLabel
    });
  }).splice(arrowToggle, numberOfColumns + arrowToggle)), calendarTime && (viewType === 'daily' && (calendarTime === null || calendarTime === void 0 ? void 0 : calendarTime.length) > 12 || viewType === 'weekly' && weeklyCountSeeMore > 0) && !expand && seeMoreToggle && /*#__PURE__*/React.createElement(SeeMoreText, {
    onClick: function onClick() {
      return onExpandHandler();
    },
    viewType: viewType
  }, /*#__PURE__*/React.createElement("span", {
    "data-analytics-id": "times-see-more ".concat(dataAnalyticsLabel),
    "data-analytics-label": dataAnalyticsLabel,
    "data-test-id": "navigate-down"
  }, viewType === 'weekly' ? ' Show' : ' See', ' ', "more times"), /*#__PURE__*/React.createElement(Icons.NavigateDown, {
    height: "11",
    width: "11",
    "data-test-id": "navigate down icon"
  })));
};

TimeSlot.propTypes = {
  /**
  Takes in an array of objects and the "datetime" as a key for the timestamp (ex: [{"datetime" : "2021-04-06T15:25:00Z"},...])
  */
  availableTimesList: arrayOf(shape({
    datetime: string.isRequired
  })).isRequired,

  /**
  Optional: If timestamp is passed or button is selected, keep the button active
  */
  activeButtonValue: string,

  /**
  Optional: Analytics click handler the arrows toggle on weekly view
  */
  analyticsClick: func,

  /**
  Optional: color for background of selected time slot
  */
  bgColorSelected: string,

  /**
  Optional: className for each individual time slot
  */
  className: string,

  /**
  Optional: Define data analytics label
  */
  dataAnalyticsLabel: string,

  /**
  Optional: Define data analytics id
  */
  dataAnalyticsId: string,

  /**
  Optional: Expand the view of the time slots
  */
  expand: bool,

  /**
  Optional: Get value of expand/ toggle
  */
  getExpandValue: func,

  /**
  Optional: Set specific end date to display in ISO format '2021-02-18T08:00:00Z'
  */
  endDate: string,

  /**
  Optional: Set specific start date to display in ISO format '2021-02-18T08:00:00Z'
  */
  startDate: string,

  /**
  Optional: Show number of columns to display
  */
  numberOfColumns: number,

  /**
  Click handler to pass back value of the time slot selected
  */
  onClick: func,

  /**
  Optional: color theme
  */
  theme: string,

  /**
  Optional: State whether the view type is 'base', 'daily', or 'weekly'
  */
  viewType: string
};
export default TimeSlot;